module.exports = __webpack_public_path__ + "static/media/amir_jaan.cad81418.jpg";